import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";
import ConstructionIcon from "@mui/icons-material/Construction";
import CalculateIcon from "@mui/icons-material/Calculate";

import {GroheBoxIcon} from "../../../../common/icons";
import LoadingDots from "../../../../ui/loadingDots";
import {ROUTES} from "../../../../../routes";
import {getCommonVisualizerType} from "../../../../../config";


const UnlockCalculationStep = (props) => {

  const {unlockCalculationsStep, stepIndex, lookPageOpened} = props;

  const getIcon = () => {
    switch (unlockCalculationsStep) {
      case 0:
        return <GroheBoxIcon/>
      case 1:
        return <ConstructionIcon/>
      case 2:
      default:
        return <CalculateIcon/>
    }
  }

  const className = "grohe-unc animated animated--quick"
    + (unlockCalculationsStep && (unlockCalculationsStep === stepIndex) ? " animate__fadeInRight" : "")
    + (stepIndex && (stepIndex > unlockCalculationsStep) ? " grohe-unc--hidden" : "")
    + (stepIndex < unlockCalculationsStep ? " animate__fadeOutLeft" : "")
    + (unlockCalculationsStep === 4 ? " hide" : "");

  const visualizerType = getCommonVisualizerType();

  return (
    <div key={stepIndex} className={className}>
      <div className={"grohe-unc__image grohe-unc__image--" + stepIndex}/>
      <div className="grohe-unc__box">
        <div className="grohe-lead__box-icon grohe-lead__box-icon--big">
          <SvgIcon style={{ fontSize: "inherit" }}>
            {getIcon()}
          </SvgIcon>
        </div>
        <h4 className="grohe-unc__box-title">
          <FormattedMessage id={"leadCaptureSteps." + stepIndex + ".title" + (lookPageOpened === ROUTES.list ? ".list" : "")}
                            values={{visualizerType}}/>
        </h4>
        <p className="grohe-unc__box-text">
          <FormattedMessage id={"leadCaptureSteps." + stepIndex + ".text"}
                            values={{visualizerType}}/>
        </p>
        <span className="grohe-unc__box-bottom-text">
          <FormattedMessage id="leadCaptureSteps.bottomText"/>
          <LoadingDots/>
        </span>
      </div>
    </div>
  )
};

UnlockCalculationStep.propTypes ={
  stepIndex: PropTypes.number.isRequired
}

const mapStateToProps = (store) => {
  const {unlockCalculationsStep} = store.unlockCalculationsState;
  const {lookPageOpened} = store.lookState;

  return {
    unlockCalculationsStep,
    lookPageOpened,
  };
};

export default connect(mapStateToProps)(UnlockCalculationStep)
